export enum PreviousCallReportSource {
  NONE = 'none',
  LOBBY = 'lobby',
}
